export enum TeamCertificationParentNameEnum {
    Admin = 'admin',
    Team = 'team',
    TeamMember = 'team-member',
    Profile = 'profile',
    Replace = 'replace',
    UserProfile = 'user-profile',
}
